module.exports = __webpack_public_path__ + "img/speaker21.bb2fb4ed.png";